import {FreightTypeSelectorProps, freightTypesSelector, useGetAllFreightTypesQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseFreightTypeMultiSelect, BaseFreightTypeMultiSelectProps} from "./BaseFreightTypeMultiSelect";

export type FreightTypeMultiSelectProps = Omit<BaseFreightTypeMultiSelectProps, "entities" | "loading"> & {
  selector?: FreightTypeSelectorProps
}

export const FreightTypeMultiSelect = (props: FreightTypeMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectFreightTypes = useMemo(() => {
    return freightTypesSelector();
  }, []);

  const {freightTypes, isLoading} = useGetAllFreightTypesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      freightTypes: selectFreightTypes(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseFreightTypeMultiSelect entities={freightTypes} loading={isLoading} {...rest} />;
};
